import { render, staticRenderFns } from "./ContactCommunications.vue?vue&type=template&id=1b60b5dc&"
import script from "./ContactCommunications.vue?vue&type=script&lang=js&"
export * from "./ContactCommunications.vue?vue&type=script&lang=js&"
import style0 from "./ContactCommunications.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports